// extracted by mini-css-extract-plugin
module.exports = {"banner":"ChristmasBanner_banner__8HS_j","bannerGift":"ChristmasBanner_bannerGift__3IVWH"};